import { useIsFeatureOn } from 'hooks/useFeatureSwitch/useIsFeatureOn';
import useProjectRoute from 'hooks/useProjectRoute';

const DEMO_ACCOUNT_IDS = [
  'zoom-usstaging',
  'zoom-us',
  'gartner-us',
  'google-ws',
];

export const useIsDemoAccount = () => {
  const { isFeatureOn } = useIsFeatureOn();
  const { accountId } = useProjectRoute();

  const isZoomDemo = isFeatureOn('zoom_demo');
  const isDemoAccount = DEMO_ACCOUNT_IDS.includes(accountId) || isZoomDemo;

  return { isDemoAccount, isZoomDemo };
};
